import { ScheduleV2 } from "../../../types";
import Avatar from '../../common/ngwAvatar';

export interface ScheduleEmpDetailsProps {
    schedule: ScheduleV2;
}

const ScheduleEmpDetails: React.FC<ScheduleEmpDetailsProps> = ({ schedule }) => {

    if(!schedule?.emp_details) return null;

    const { emp_name, image_url } = schedule.emp_details;

    return (
        <div className="border rounded-lg p-4 bg-gray-50 shadow flex items-center space-x-4">
            <Avatar src={image_url} name={emp_name} className="w-12 h-12" />
            <div>
                {emp_name && (<div className="text-sm text-gray-700 font-medium">{emp_name}</div>)}
            </div>
        </div>
    );
};


export default ScheduleEmpDetails;
